module.exports = __webpack_public_path__ + "d692cd261cdb5fddab55e51cb48eba57.svg";